// Этот файл генерируется автоматически, его не следует редактировать вручную
import dynamicDiagram from '@/widgets/dynamicDiagram.js';
import dynamicDiagramPercent from '@/widgets/dynamicDiagramPercent.js';
import faqList from '@/widgets/faqList.js';
import filterCategories from '@/widgets/filterCategories.js';
import filterItem from '@/widgets/filterItem.js';
import form from '@/widgets/form.js';
import globalEventButton from '@/widgets/globalEventButton.js';
import headerScroll from '@/widgets/headerScroll.js';
import mapBlockContact from '@/widgets/mapBlockContact.js';
import popupFilter from '@/widgets/popupFilter.js';
import popupMenu from '@/widgets/popupMenu.js';
import popupTeam from '@/widgets/popupTeam.js';
import scrollTop from '@/widgets/scrollTop.js';
import sliderChoose from '@/widgets/sliderChoose.js';
import sliderMain from '@/widgets/sliderMain.js';
import sliderPartners from '@/widgets/sliderPartners.js';
import structChart from '@/widgets/structChart.js';

export default {
  'collapse': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/collapse.js'),
  'dynamicDiagram': async () => { return { default: dynamicDiagram }; },
  'dynamicDiagramPercent': async () => { return { default: dynamicDiagramPercent }; },
  'faqList': async () => { return { default: faqList }; },
  'filterCategories': async () => { return { default: filterCategories }; },
  'filterItem': async () => { return { default: filterItem }; },
  'form': async () => { return { default: form }; },
  'globalEventButton': async () => { return { default: globalEventButton }; },
  'headerScroll': async () => { return { default: headerScroll }; },
  'mapBlockContact': async () => { return { default: mapBlockContact }; },
  'popupFilter': async () => { return { default: popupFilter }; },
  'popupMenu': async () => { return { default: popupMenu }; },
  'popupTeam': async () => { return { default: popupTeam }; },
  'scrollTop': async () => { return { default: scrollTop }; },
  'scrollWatcher': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/scrollWatcher.js'),
  'sliderChoose': async () => { return { default: sliderChoose }; },
  'sliderMain': async () => { return { default: sliderMain }; },
  'sliderPartners': async () => { return { default: sliderPartners }; },
  'structChart': async () => { return { default: structChart }; },
  'tabsSwitch': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/tabsSwitch.js'),
  'telephoneMask': async () => await import( /* webpackMode: "lazy-once" */ /* webpackChunkName: "secondary" */ '@/widgets/telephoneMask.js')
};
